/**
 * Map icon utilities for the grid widget
 */

export const ICON_ATTRS = [
  "data-map-icon-mode",
  "data-map-icon-fa-family",
  "data-map-icon-fa-icon",
  "data-map-icon-size",
  "data-map-icon-color",
  "data-map-icon-svg",
];

export function mapStyleToIconSpec(m = {}) {
  const mode = m.mode === "svg" ? "svg" : "fa";
  return {
    mode,
    faFamily: m.faFamily || "fa-solid",
    faIcon: m.faIcon || "fa-location-dot",
    size: Number.isFinite(m.iconSize) ? m.iconSize : 28,
    color: m.iconColor || "#fe5922",
    svg: m.customSvg || "",
  };
}

export function applyIconSpecToEl(el, spec) {
  if (!el || !spec) return;
  el.setAttribute("data-map-icon-mode", spec.mode);
  el.setAttribute("data-map-icon-color", spec.color);
  el.setAttribute("data-map-icon-size", String(spec.size));
  if (spec.mode === "fa") {
    el.setAttribute("data-map-icon-fa-family", spec.faFamily || "fa-solid");
    el.setAttribute("data-map-icon-fa-icon", spec.faIcon || "fa-location-dot");
    el.removeAttribute("data-map-icon-svg");
  } else {
    el.setAttribute("data-map-icon-svg", spec.svg || "");
    el.removeAttribute("data-map-icon-fa-family");
    el.removeAttribute("data-map-icon-fa-icon");
  }
}
